
































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import HeaderLanguageSelector from '@shared/layouts/components/header/header-language-selector.vue';

@Component({
  name: 'bpc-auth-layout',
  components: {
    'bpc-header-language-selector': HeaderLanguageSelector,
  },
})
export default class AuthLayout extends Vue {
  get tenantAlias(): string {
    return this.$clientRouter.getTenantAlias();
  }

  defaultBackground: string = 'background-color: rgba(15, 58, 93, 0.85)';

  get background() {
    return this.tenantBackground
      ? `background-image: url("${this.tenantBackground}")`
      : this.defaultBackground;
  }

  get logo() {
    return `background-image: url("${this.tenantLogo}")`;
  }

  async beforeMount() {
    if (!this.selectedUserLang && this.lang !== this.defaultLanguage) {
      await this.translationService.getTranslations(this.defaultLanguage);
    }
  }

  get lang(): string {
    return this.$store.getters['auth/userLang'] || this.$i18n.locale;
  }

  get settingsLoaded() {
    return !this.$store.getters['centerSettings/isLoading'];
  }

  get tenantBackground() {
    if (
      this.$store.getters['centerSettings/centerSettings'] &&
      this.$store.getters['centerSettings/centerSettings'].background
    ) {
      let background = this.$store.getters['centerSettings/centerSettings'].background;
      if (typeof background === 'string') {
        background = JSON.parse(background);
      }
      return background.url;
    }
    return null;
  }
  get tenantLogo() {
    if (
      this.$store.getters['centerSettings/centerSettings'] &&
      this.$store.getters['centerSettings/centerSettings'].logo_url
    ) {
      let logo = this.$store.getters['centerSettings/centerSettings'].logo_url;
      if (logo && typeof logo === 'string') {
        logo = JSON.parse(logo);
      }
      return logo.url;
    }
    return null;
  }

  get availableLanguages() {
    if (this.$store.getters['centerSettings/centerSettings']) {
      return this.$store.getters['centerSettings/centerSettings'].available_languages;
    }
    return null;
  }

  get selectedUserLang() {
    return this.$store.getters['auth/userLang'];
  }

  get defaultLanguage() {
    if (this.$store.getters['centerSettings/centerSettings']) {
      return this.$store.getters['centerSettings/defaultLanguage'];
    }
    return null;
  }
  get allowAccessPublicWebpage() {
    return this.$store.getters['centerSettings/centerSettings']?.allow_access_public_website;
  }
}
